import { render, staticRenderFns } from "./editInformation.vue?vue&type=template&id=3103dc46&"
import script from "./editInformation.vue?vue&type=script&lang=js&"
export * from "./editInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports